import { Dialog } from "@mui/material";
import React, { useState } from "react";
import Button from "../UniversalComponents/DefaultButton";
import LabelComponent from "../UniversalComponents/LabelComponent";
import InputComponent from "../UniversalComponents/InputComponent";
import { ReactComponent as CloseIcon } from "../../assets/images/crossIcon.svg";

const AddSection = ({ open, onClose }) => {
  const [formData, setFormData] = useState({
    section_name: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.section_name.trim()) {
      setErrors({ section_name: "Section name is required" });
      return;
    }

    const payload = {
      section_name: formData.section_name.trim(),
    };

    try {
      console.log("API Payload:", payload);

      setFormData({ section_name: "" });
      setErrors({});
      onClose();
    } catch (error) {
      console.error("API Error:", error.message);
      setErrors({ section_name: "Failed to save section. Please try again." });
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <form onSubmit={handleSubmit}>
        <div className="border-b">
          <div className="flex justify-between items-center p-3">
            <h3 className="ytext-16 text-[#434852] font-500">Add New Section</h3>
            <button className="pr-2" onClick={onClose} type="button">
              <CloseIcon />
            </button>
          </div>
        </div>
        <div className="border-b">
          <div className="p-3">
            <LabelComponent htmlFor="section_name" labelText="Section Name" size="small" isMandatory />
            <InputComponent
              type="text"
              id="section_name"
              name="section_name"
              placeholder="Enter Section Name"
              value={formData.section_name}
              onChange={handleChange}
              mandatory
              error={errors.section_name}
            />
            {errors.section_name && <p className="text-red-500 text-sm mt-1">{errors.section_name}</p>}
          </div>
        </div>
        <div className="flex p-3 justify-end gap-3">
          <Button variant="secondary" onClick={onClose} type="button">
            CANCEL
          </Button>
          <Button variant="primary" type="submit">
            SAVE
          </Button>
        </div>
      </form>
    </Dialog>
  );
};

export default AddSection;
